/**
 * @generated SignedSource<<39101869367651ed62d9a14d0b55945a>>
 * @relayHash 21160f4c08969a5c7a1dd4965219e591
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ffc88b0828b5ecff8c5d4370181b8f3911e255debdd1d51343da5a90c2c445b9

import type { ConcreteRequest } from 'relay-runtime';
export type ContentStateRestrictionLevel = "NONE" | "PAGE_OWNER" | "%future added value";
export type ContentStateInput = {
  color?: string | null | undefined;
  id?: AGG$Long | null | undefined;
  name?: string | null | undefined;
  spaceKey?: string | null | undefined;
};
export type EditorContentStateComponentSetContentStateMutation$variables = {
  contentId: string;
  contentStateInput: ContentStateInput;
};
export type EditorContentStateComponentSetContentStateMutation$data = {
  readonly setContentState: {
    readonly color: string;
    readonly id: string | null | undefined;
    readonly name: string;
    readonly restrictionLevel: ContentStateRestrictionLevel;
  } | null | undefined;
};
export type EditorContentStateComponentSetContentStateMutation = {
  response: EditorContentStateComponentSetContentStateMutation$data;
  variables: EditorContentStateComponentSetContentStateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentStateInput"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "contentState",
        "variableName": "contentStateInput"
      }
    ],
    "concreteType": "ContentState",
    "kind": "LinkedField",
    "name": "setContentState",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "name"
      },
      {
        "kind": "ScalarField",
        "name": "color"
      },
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "restrictionLevel"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "EditorContentStateComponentSetContentStateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditorContentStateComponentSetContentStateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "21160f4c08969a5c7a1dd4965219e591",
    "id": "ffc88b0828b5ecff8c5d4370181b8f3911e255debdd1d51343da5a90c2c445b9",
    "metadata": {},
    "name": "EditorContentStateComponentSetContentStateMutation",
    "operationKind": "mutation",
    "text": "mutation EditorContentStateComponentSetContentStateMutation($contentId:ID!,$contentStateInput:ContentStateInput!){setContentState(contentId:$contentId,contentState:$contentStateInput){name,color,id,restrictionLevel}}"
  }
};
})();

(node as any).hash = "60cf99b28a7e5ae862709c088b41effb";

export default node;
